/* eslint-env browser */
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useRecoilValue } from 'recoil';
import ClientSideConfigSelector from '../../../../recoil/cashout/ClientSideConfigSelector';

export default function CashoutTransactionModal({ transaction, onClose }) {
  const { t } = useTranslation(null, { useSuspense: false });

  const config = useRecoilValue(ClientSideConfigSelector);
  const {
    live: {
      claimReward: {
        supportMail: emailAddress = '',
      } = {},
    } = {},
  } = config || {};

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', onKeyDown);

    return () => {
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [onClose]);

  if (!transaction) {
    return null;
  }

  const title = 'Cash Reward Support Request';

  const body = [
    `User: ${transaction.user}`,
    `Diamonds: ${transaction.diamonds}`,
    `Order: ${transaction.id}`,
    `Application time: ${transaction.date} ${transaction.time}`,
    '',
    'Please describe your support request',
  ].join('\n');

  const mailToLink = `mailto:${emailAddress}?subject=${title}&body=${encodeURIComponent(body)}`;

  return (
    <div
      id="transaction-details"
      className="phoenix-simple-dialog-view modal fade member-diamonds-cash-history-item in show"
      aria-hidden="false"
    >
      <div className="modal-backdrop fade in" />
      <div className="modal-dialog">
        <div className="modal-content modal-content-sm">
          <div className="modal-header">
            <hr />
          </div>
          {/* eslint-disable-next-line jsx-a11y/no-redundant-roles */}
          <form className="form-horizontal" role="form">
            <div className="modal-body">
              <div className="form-group">
                <ul>
                  <li>
                    <div>
                      {t('history_diamonds')}
                      :
                    </div>
                    <div id="transaction-diamonds">{transaction.diamonds}</div>
                  </li>
                  <li>
                    <div>
                      {t('history_status')}
                      :
                    </div>
                    <div
                      id="transaction-status"
                      className="text-transform: capitalize"
                    >
                      {transaction.translatedStatus}
                    </div>
                  </li>
                  <li>
                    <div>
                      {t('history_order')}
                      :
                    </div>
                    <div
                      id="transaction-id"
                      className="member-diamonds-cash-history-item-order-number"
                    >
                      {transaction.id}
                    </div>
                  </li>
                  <li>
                    <div>
                      {t('history_processor_id')}
                      :
                    </div>
                    <div
                      id="transaction-paypal"
                      className="member-diamonds-cash-history-item-processor-id"
                    >
                      {transaction.processor || 'N/A'}
                    </div>
                  </li>
                  <li>
                    <div>
                      {t('history_processor_order')}
                      :
                    </div>
                    <div id="transaction-external-id">
                      {transaction.externalId || 'N/A'}
                    </div>
                  </li>
                  <li>
                    <div>
                      {t('history_application_time')}
                      :
                    </div>
                    <div>
                      <span id="transaction-date">{transaction.date}</span>
                      {' '}
                      <span id="transaction-time">{transaction.time}</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="modal-footer">
              <div className="form-group">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-dismiss="modal"
                  aria-hidden="true"
                  onClick={onClose}
                >
                  {t('cashout_ok')}
                </button>
              </div>
              <div className="form-group">
                <a
                  id="support-email"
                  type="button"
                  className="btn btn-undesired"
                  aria-hidden="true"
                  href={mailToLink}
                >
                  {t('history_support')}
                </a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
CashoutTransactionModal.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  transaction: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};
